<main>
  <div class="fieldContainer">


    <mat-form-field>
      <mat-label>Veuillez entrer votre email</mat-label>
      <input matInput placeholder="email@example.com" [formControl]="email" required>
      <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
  </div>
  <div class="buttonContainer">
    <button mat-raised-button color="primary" [disabled]="!email.valid" (click)="setEmail()"> Valider </button>
    <button mat-raised-button color="warn" mat-dialog-close>Annuler</button>
  </div>

</main>
